<template>
    <div class="app-topnav">

        <div class="wrap">
            <div style="font-size: 12px; color: #cdcdcd;">
                {{ $t('欢迎来到') }} {{ gsinfo.gsmc }} {{ $t('网站') }}！
            </div>
            <ul>
                <li>
                    <lang class="margin" />
                </li>
                <li><router-link to="/">{{ $t("首页") }}</router-link></li>
                <li v-if="dwinfo"><a href="javascript:;"><i class="el-icon-user"></i>{{ dwinfo.dwmc
                }}</a></li>
                <li v-if="dwinfo">
                    <el-popconfirm :title="$t('确认退出吗') + '?'" :confirm-button-text="$t('确认')"
                        :cancel-button-text="$t('取消')" @confirm="loginOut">
                        <template #reference>
                            <a href="javascript:;">{{ $t('退出登录') }}</a>
                        </template>
                    </el-popconfirm>
                </li>
                <li v-if="!dwinfo"><router-link to="/login">{{ $t('登录账号') }}</router-link></li>
                <li v-if="dwinfo"><router-link to="/order">{{ $t('我的订单') }}</router-link></li>
                <li v-if="dwinfo">
                    <el-badge :value="cartItems.length" class="item">
                        <router-link to="/shopCar">{{ $t('购物车') }}</router-link>
                    </el-badge>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    name: "TopBar",
    created() {
        this.dwinfo = JSON.parse(localStorage.getItem("dwinfo"))
        this.getGs()
    },
    data() {
        return {
            dwinfo: {},
            gsinfo: {},
        };
    },

    computed: {
        cartItems() {
            const items = this.$store.getters['common/cartItems1'];
            console.log('Cart Items:', items);
            return items;
        }
    },
    methods: {
        async getGs() {
            // this.$store.commit("common/ClearCartItemwh", );
            const backData = await this.$API.HKAPI({
                type: "getgsxx",
            });
            if (backData.data.gsbh) {
                this.gsinfo = backData.data;
            }
        },
        loginOut() {
            this.$store.commit("common/ClearCartItemw");
            localStorage.clear();
            this.$router.push({
                name: "login",
            });
        },
    }
}
</script>

<style scoped lang="less">
.app-topnav {
    background: #333;
    width: 100%;
    font-size: 14px;
    height: 50px;
    display: flex;
    align-items: center;

    .wrap {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        max-width: 1200px;
        /* 可以根据需要调整最大宽度 */
        margin: 0 auto;
        /* 水平居中 */

        ul {
            display: flex;
            height: 53px;
            justify-content: flex-end;
            align-items: center;

            li {
                a {
                    padding: 0 15px;
                    color: #cdcdcd;
                    line-height: 1;
                    display: inline-block;

                    i {
                        font-size: 14px;
                        margin-right: 2px;
                    }

                    &:hover {
                        color: #fff
                    }
                }

                &+li {
                    a {
                        border-left: 2px solid #666;
                    }
                }
            }
        }
    }
}
</style>